namespace GeniuzPOS.Inventory {
    export interface IcStockReceiveDtRow {
        Id?: number;
        SysDocNo?: string;
        LineItemNo?: number;
        SkuCode?: string;
        ItemRemark?: string;
        Qty?: number;
        UnitCost?: number;
        UnitChange?: UnitChangeEnumFg;
        PurUnit?: string;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        CostValue?: number;
        LastPurPrice?: number;
        ExpDate?: string;
        Remark?: string;
        StkQty?: number;
        QtyUse?: number;
        UseFg?: number;
        PIRefFg?: string;
        PILineId?: number;
    }

    export namespace IcStockReceiveDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockReceiveDt';
        export const lookupKey = 'Inventory.IcStockReceiveDt';

        export function getLookup(): Q.Lookup<IcStockReceiveDtRow> {
            return Q.getLookup<IcStockReceiveDtRow>('Inventory.IcStockReceiveDt');
        }
        export const deletePermission = '2Inventory:รายการ:รับเข้า:Modify';
        export const insertPermission = '2Inventory:รายการ:รับเข้า:Modify';
        export const readPermission = '2Inventory:รายการ:รับเข้า:View';
        export const updatePermission = '2Inventory:รายการ:รับเข้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            ItemRemark = "ItemRemark",
            Qty = "Qty",
            UnitCost = "UnitCost",
            UnitChange = "UnitChange",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            CostValue = "CostValue",
            LastPurPrice = "LastPurPrice",
            ExpDate = "ExpDate",
            Remark = "Remark",
            StkQty = "StkQty",
            QtyUse = "QtyUse",
            UseFg = "UseFg",
            PIRefFg = "PIRefFg",
            PILineId = "PILineId"
        }
    }
}
